import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface AccordionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

export default function Accordion({ title, children, defaultOpen = false }: AccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="bg-white dark:bg-navy-900 rounded-xl shadow-lg border border-navy-200 dark:border-navy-700 overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-6 py-4 flex justify-between items-center text-left hover:bg-navy-50 dark:hover:bg-navy-800/50 transition-colors duration-200"
      >
        <h2 className="text-lg font-semibold text-navy-900 dark:text-navy-50">{title}</h2>
        {isOpen ? (
          <ChevronUp className="h-5 w-5 text-accent-500 dark:text-accent-400" />
        ) : (
          <ChevronDown className="h-5 w-5 text-navy-400 dark:text-navy-500" />
        )}
      </button>

      <div
        className={`transition-all duration-300 ease-in-out ${
          isOpen ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
        }`}
      >
        <div className="px-6 pb-6 border-t border-navy-100 dark:border-navy-800 pt-4">
          {children}
        </div>
      </div>
    </div>
  );
}
